export default [
  {
    path: '/wczq',
    component: () => import('./views/index')
  },
  {
    path: '/wczq/article/detail',
    component: () => import('./views/article/detail')
  }
]



// WEBPACK FOOTER //
// ./src/page/wczq/router.js